import { cn } from '~/lib/utils';

interface LoadingProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  text?: string;
  centered?: boolean;
}

const sizeClasses = {
  sm: 'h-2 w-2',
  md: 'h-4 w-4',
  lg: 'h-6 w-6',
};

export function Loading({ size = 'md', className, text = 'Loading...', centered = false }: LoadingProps) {
  const dotSize = sizeClasses[size];

  const content = (
    <>
      <span className="sr-only">{text}</span>
      <div className={cn('rounded-full animate-bounce [animation-delay:-0.3s] bg-muted-foreground', dotSize)}></div>
      <div className={cn('rounded-full animate-bounce [animation-delay:-0.15s] bg-muted-foreground', dotSize)}></div>
      <div className={cn('rounded-full animate-bounce bg-muted-foreground', dotSize)}></div>
    </>
  );

  if (centered) {
    return <div className={cn('flex space-x-2 justify-center items-center', className)}>{content}</div>;
  }

  return <div className={cn('flex space-x-2', className)}>{content}</div>;
}

export function FullScreenLoading({ text = 'Loading...' }: { text?: string }) {
  return (
    <div className="fixed inset-0 flex space-x-2 justify-center items-center h-screen transition-colors bg-background text-foreground">
      <span className="sr-only">{text}</span>
      <div className="h-4 w-4 rounded-full animate-bounce [animation-delay:-0.3s] bg-muted-foreground"></div>
      <div className="h-4 w-4 rounded-full animate-bounce [animation-delay:-0.15s] bg-muted-foreground"></div>
      <div className="h-4 w-4 rounded-full animate-bounce bg-muted-foreground"></div>
    </div>
  );
}
